export const API_BASE_URL = "https://e-commerce-backend-ln20.onrender.com";